import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import BusinessProcess from './components/BusinessProcess';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

// Lazy load páginas para reducir bundle inicial
const About = lazy(() => import('./pages/About'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const SuggestionBox = lazy(() => import('./pages/SuggestionBox'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen relative bg-white overflow-x-hidden">
        <WhatsAppButton />
        <Navbar />
        <main className="flex-grow relative z-10">
          <Suspense fallback={
            <div className="flex items-center justify-center min-h-screen">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
            </div>
          }>
            <Routes>
              <Route path="/" element={
                <>
                  <div className="hero-section">
                    <Hero />
                  </div>
                  <div className="process-section">
                    <BusinessProcess />
                  </div>
                </>
              } />
              <Route path="/about" element={<About />} />
              <Route path="/servicios" element={<ServicesPage />} />
              <Route path="/sugerencias" element={<SuggestionBox />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 